import {MixModel, ProjectDataIndex, ProjectTab} from '../../../api/types.ts';
import VibeCodeComponent from '../../vibe_code/VibeCodeComponent.tsx';

interface ProjectTabVibeCodeProps {
    mix: MixModel;
    tab: ProjectTab;
    dataIndex: ProjectDataIndex;
    readOnly: boolean;
    isFocusMode?: boolean;
    onExitFocusMode?: () => void;
    autoOpenVibe?: boolean;
    // With autoOpenVibe on a copy: translate it into this language.
    autoVibeLanguage?: string | null;
    onVibeAutoOpened?: () => void;
}

const ProjectTabVibeCode: React.FC<ProjectTabVibeCodeProps> = ({
    mix,
    dataIndex,
    readOnly,
    isFocusMode,
    onExitFocusMode,
    autoOpenVibe,
    autoVibeLanguage,
    onVibeAutoOpened
}) => {
    return (
        <VibeCodeComponent
            project={mix}
            dataIndex={dataIndex}
            readOnly={readOnly}
            isFocusMode={isFocusMode}
            onExitFocusMode={onExitFocusMode}
            autoOpenVibe={autoOpenVibe}
            autoVibeLanguage={autoVibeLanguage}
            onVibeAutoOpened={onVibeAutoOpened}
        />
    );
};

export default ProjectTabVibeCode;
